import type { FC, ReactNode } from 'react'
import type { MovementType } from '@/types'

import { cn } from '@/lib/utils'
import { MOVEMENT_TYPE_META } from '@/constants/inventory'
import { ArrowDownToLine, ArrowUpFromLine, SlidersHorizontal } from 'lucide-react'

interface MovementTypeBadgeProps {
    type: MovementType
    className?: string
}

const STYLES: Record<MovementType, string> = {
    entrada: 'bg-flow-in-soft text-flow-in-ink',
    salida: 'bg-flow-out-soft text-flow-out-ink',
    ajuste: 'bg-flow-adjust-soft text-flow-adjust-ink'
}

export const MOVEMENT_ICONS = {
    entrada: ArrowDownToLine,
    salida: ArrowUpFromLine,
    ajuste: SlidersHorizontal
}

const MovementTypeBadge: FC<MovementTypeBadgeProps> = ({ type, className }): ReactNode => {
    const Icon = MOVEMENT_ICONS[type]

    return (
        <span
            className={cn(
                'inline-flex h-6 shrink-0 items-center gap-1 rounded-full px-2 text-xs font-medium whitespace-nowrap',
                STYLES[type],
                className
            )}
        >
            <Icon className='size-3.5' aria-hidden='true' />
            {MOVEMENT_TYPE_META[type].label}
        </span>
    )
}

export default MovementTypeBadge
